import baseFilters, { baseTagFilter } from '@/app/dashboard/filters';
import {
  defaultBooleanFilter,
  defaultRelationFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import { ComponentTypeConfig } from '@pigello/pigello-matrix';

const componentTypeFilters: Filter[] = [
  {
    ...defaultStringFilter,
    title: ComponentTypeConfig.fields.name.verboseName,
    externalFieldName: ComponentTypeConfig.fields.name.externalFieldName,
  },
  {
    ...defaultBooleanFilter,
    title: ComponentTypeConfig.fields.includeInInspections.verboseName,
    externalFieldName:
      ComponentTypeConfig.fields.includeInInspections.externalFieldName,
  },
  {
    ...defaultRelationFilter,
    title: ComponentTypeConfig.fields.proposedRoomCategories.verboseName,
    externalFieldName:
      ComponentTypeConfig.fields.proposedRoomCategories.externalFieldName,
  },

  ...baseTagFilter,
  ...baseFilters,
];

export default componentTypeFilters;
